<template>
  <div v-if="screenWidth < 998 && result" class="menu-mobile">
    <svg class="menu-mobile__button" @click="openMenu = true">
      <use xlink:href="#svg-burger"></use>
    </svg>

    <transition name="open-main-menu">
      <div
        v-show="openMenu"
        class="menu-mobile__block"
        :class="{ 'menu-mobile_off-scroll': subMenu }"
        @click.self="handlerAnotherClick"
      >
        <div class="menu-mobile__limit">
          <div class="menu-mobile__header">
            <a :href="result?.links?.mainPage?.href">
              <svg class="menu-mobile__logo">
                <use xlink:href="#svg-mobile-menu-logo"></use>
              </svg>
            </a>
            <Cities />
            <svg class="menu-mobile__close" @click="openMenu = false">
              <use xlink:href="#svg-close"></use>
            </svg>
          </div>
          <div class="menu-mobile__scroll">
            <div class="menu-mobile__links">
              <span class="menu-mobile__link" @click="changeOpenSmallBasket(true)">
                <svg>
                  <use xlink:href="#svg-basket"></use>
                </svg>
                {{ basketMessages?.basket }}
              </span>
              <a
                v-if="result.links.favorite"
                :href="result?.links?.favorite?.href"
                class="menu-mobile__link"
              >
                <svg>
                  <use xlink:href="#svg-like"></use>
                </svg>
                {{ result?.links?.favorite?.name }}
              </a>

              <a
                v-if="result.isAuthorized"
                :href="result?.links?.cabinet?.href"
                class="menu-mobile__link"
              >
                <svg>
                  <use xlink:href="#svg-user"></use>
                </svg>
                {{ messages.user_name }}
              </a>
              <a
                v-else
                href="javascript: void(0)"
                class="menu-mobile__link"
                @click="openModalEnter"
              >
                <svg>
                  <use xlink:href="#svg-user"></use>
                </svg>
                {{ result?.links?.cabinet?.name }}
              </a>
            </div>

            <div class="menu-mobile__menu">
              <MenuMobileCatalog
                ref="mobileMenu"
                :menu-obj="items"
                :big-menu="true"
                :messages="result.message"
                @open-menu="openSubMenu"
              />
            </div>
            <div v-for="section in sections" class="menu-mobile__section">
              <span class="menu-mobile__title">{{ section.title }}</span>
              <a v-for="item in section.items" :href="item?.href">{{ item.name }}</a>
            </div>

            <div v-if="siteLanguages?.langs" class="menu-mobile__section">
              <span class="menu-mobile__title">{{ siteLanguages?.messages?.lang }}</span>
              <div class="lang">
                <a
                  v-for="lang in siteLanguages.langs"
                  :href="lang.link"
                  :class="{ lang__link_active: lang.current }"
                  class="lang__link"
                >
                  {{ lang.name }}
                </a>
              </div>
            </div>
            <div class="menu-mobile__bottom">
              <a class="menu-mobile-map" :href="result?.links?.shops?.href">
                <svg class="menu-mobile-map__icon">
                  <use xlink:href="#svg-diamond"></use>
                </svg>
                <span class="menu-mobile-map__text">
                  {{ result?.links?.shops?.name }}
                </span>
              </a>
              <a class="menu-mobile-phone" :href="result?.links?.phone?.href">
                <span class="menu-mobile-phone__number"> {{ result?.links?.phone?.name }} </span>
                <span class="menu-mobile-phone__text" v-html="result.message.freeCall"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Cities from '@components/Cities/Cities.vue';
import EnterCabinet from '@components/Cabinet/EnterCabinet/EnterCabinet.vue';
import useModal from '@use/useModal/useModal';
import { screenWidth } from '@use/useDeviceInfo';
import MenuMobileCatalog from '@components/Menus/MenuMobileCatalog.vue';

export default {
  name: 'MenuMobile',
  components: { MenuMobileCatalog, Cities },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      openMenu: false,
      subMenu: false,
      screenWidth,
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ personal }) => personal.data?.authInfo,
      basketMessages: ({ basket }) => basket.data?.messages,
      siteLanguages: ({ results }) => results.siteLanguages,
      items: ({ results }) => results?.menus?.mainMenu?.items,
    }),
    sections() {
      const keys = ['mobile_top_1', 'mobile_top_2'];
      const result = [];

      keys.map((value) => {
        result.push(JSON.parse(localStorage.getItem(value)));
      });

      return result;
    },
  },
  watch: {
    openMenu(val) {
      if (val) {
        document.body.classList.add('overflow');
      } else {
        document.body.classList.remove('overflow');
      }
    },
  },
  methods: {
    ...mapMutations({
      changeOpenSmallBasket: 'basket/changeOpenSmallBasket',
    }),
    openSubMenu(isOpen) {
      // this.subMenu = isOpen;
    },
    openModalEnter() {
      this.modal.show(EnterCabinet, {}, { width: '440px' });
    },
    handlerAnotherClick() {
      this.openMenu = false;
      if (this.$refs.mobileMenu) {
        this.$refs.mobileMenu.isMenuActive = false;
        this.$refs.mobileMenu.isSubMenuActive = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile {
  color: #191918;
  margin-right: 16px;
  width: 24px;
  height: 24px;
  &__block {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6;
    height: 100%;
    overflow: hidden;
    width: 100vw;
    &:before {
      content: '';
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      //background-color: rgba(0, 0, 0, 0.6);
      background-color: rgba(0, 0, 0, 0.6);
      transition: 0.3s linear background-color;
      z-index: -1;
    }
  }
  &__limit {
    //width: calc(100% - 65px);
    background-color: #fff;
    height: 100%;
  }

  &_off-scroll {
    overflow: hidden;
  }

  &__scroll {
    overflow-y: auto;
    max-height: calc(100% - 58px);
  }

  &__links {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
  }

  &__section {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 40px;
    padding: 8px 16px;
    line-height: 100%;
    color: #363636;
    position: relative;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    &:after {
      content: '';
      position: absolute;
      height: 1px;
      background-color: #dfdfdf;
      margin-top: 8px;
      bottom: 0;
      left: 16px;
      right: 16px;
    }

    & > * {
      display: flex;
      align-items: center;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    height: 54px;

    svg {
      width: 20px;
      height: 20px;
      transform: translateY(-3px);
      margin-right: 8px;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    //justify-content: space-between;
    background: #b8d9ec;
    height: 60px;
    padding: 0 16px;
  }

  &__logo {
    width: 104px;
    height: 28px;
    margin-right: 24px;
  }

  &__close {
    width: 18px;
    height: 18px;
    fill: #191918;
    margin-left: auto;
  }

  &__button {
    width: 24px;
    height: 24px;

    &:hover {
      cursor: pointer;
    }
  }

  &__menu {
    position: relative;
    padding: 0 16px 8px;
    display: flex;
    align-items: center;
    font-size: rem(16);
    line-height: 100%;
    color: #363636;
    min-height: 72px;
    &:after {
      content: '';
      position: absolute;
      height: 1px;
      background-color: #dfdfdf;
      bottom: 0;
      left: 16px;
      right: 16px;
    }
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 100%; /* 14px */
    letter-spacing: 1.4px;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    padding: 24px;
  }

  :deep(.nav-menu__toggle) {
    display: flex;
    justify-content: center;
    height: 48px;
    background-color: #618eaf;
    color: #fff;
  }

  :deep(.menu-mobile__squares) {
    fill: #fff;
  }
}
.menu-mobile-map {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &__icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    fill: #191918;
    transform: translateY(-2px);
  }

  &__text {
    text-decoration: underline;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
  }
}

.menu-mobile-phone {
  display: flex;
  flex-direction: column;
  color: #757575;
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  margin-bottom: 16px;
  &__number {
    color: #191918;
    font-size: 20px;
    font-weight: 600;
    line-height: 115%;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
}

.lang {
  display: grid;
  grid-template-columns: repeat(2, 34px);
  grid-column-gap: 8px;
  &__link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    color: var(--text-colour-secondary);
    font-size: 14px;
    font-weight: 500;
    line-height: 12px;
    border-radius: 4px;
    border: 1px solid currentColor;

    &_active {
      background-color: var(--text-colour-secondary);
      color: #fff;
    }
  }
}

.open-main-menu-enter-active,
.open-main-menu-leave-active {
  transition: left 0.3s linear;
}

.open-main-menu-enter-active,
.open-main-menu-leave-active {
  left: 0;
  &:before {
    background-color: rgba(0, 0, 0, 0.6);
  }
}

.open-main-menu-enter-from,
.open-main-menu-leave-to {
  left: -100%;
  &:before {
    background-color: rgba(0, 0, 0, 0);
  }
}
</style>
